export default {"src":"/_next/static/media/google_logo.09765cc2.svg","height":96,"width":95};